import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCloudDownload = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M10.81 2.118a7.777 7.777 0 0 1 2.736.007 7.497 7.497 0 0 1 2.54.956 6.847 6.847 0 0 1 1.97 1.786 6.227 6.227 0 0 1 1.082 2.373c.091.42.137.848.137 1.275a4.845 4.845 0 0 1-.12 9.688 1.077 1.077 0 1 1 0-2.154 2.691 2.691 0 1 0 0-5.382H18.08a1.076 1.076 0 0 1-1.05-1.313 3.838 3.838 0 0 0 .005-1.656 4.075 4.075 0 0 0-.71-1.553 4.696 4.696 0 0 0-1.353-1.222 5.344 5.344 0 0 0-1.81-.68 5.623 5.623 0 0 0-1.978-.005 5.352 5.352 0 0 0-1.815.67c-1.102.659-1.834 1.662-2.081 2.765-.114.507-.574.86-1.094.84a4.032 4.032 0 0 0-2.52.75 3.65 3.65 0 0 0-1.416 2.066 3.474 3.474 0 0 0 .28 2.43 3.781 3.781 0 0 0 1.868 1.734 1.077 1.077 0 0 1-.86 1.974 5.935 5.935 0 0 1-2.925-2.73 5.627 5.627 0 0 1-.452-3.93 5.803 5.803 0 0 1 2.245-3.29A6.16 6.16 0 0 1 5.43 6.386c.518-1.373 1.52-2.54 2.834-3.325a7.505 7.505 0 0 1 2.546-.942Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M11.62 10.666c.594 0 1.076.482 1.076 1.077v9.69a1.077 1.077 0 1 1-2.153 0v-9.69c0-.595.482-1.077 1.076-1.077Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M7.628 17.441c.42-.42 1.102-.42 1.523 0l2.468 2.469 2.469-2.469a1.077 1.077 0 0 1 1.522 1.523l-3.23 3.23c-.42.42-1.102.42-1.522 0l-3.23-3.23a1.077 1.077 0 0 1 0-1.523Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCloudDownload);
export default ForwardRef;
